import {
  COUNTRY,
  END_DATE_MARKER,
  FLAG,
  PREP_END_DATE_MARKER,
  PREP_START_DATE_MARKER,
  START_DATE_MARKER,
  TIME_COUNTDOWN_MARKER,
  ZIPCODE,
  defaultVariablesColor,
} from '@/constants/string';
import { ActionList, Icon, Popover } from '@shopify/polaris';
import { CodeAddIcon } from '@shopify/polaris-icons';
import { useCallback, useMemo, useState } from 'react';

const VariableButton = ({ disabled, onFocus }: { disabled?: boolean; onFocus: () => void }) => {
  const [popoverActive, setPopoverActive] = useState(false);
  const [savedRange, setSavedRange] = useState<Range | null>(null);
  const togglePopoverActive = useCallback(() => {
    const selection = window.getSelection();
    if (selection && selection.rangeCount > 0) {
      setSavedRange(selection.getRangeAt(0).cloneRange());
    }
    setPopoverActive((popoverActive) => !popoverActive);
  }, []);

  const handleAddText = useCallback(
    (text: string) => {
      if (savedRange) {
        const selection = window.getSelection();
        selection?.removeAllRanges();
        selection?.addRange(savedRange);
      }
      onFocus();
      document.execCommand('insertHTML', false, text);
      setPopoverActive(false);
    },
    [onFocus, savedRange],
  );

  const commonActions = useMemo(() => {
    return [
      {
        content: `${TIME_COUNTDOWN_MARKER}`,
        onAction: () => {
          handleAddText(` <strong style="color: ${defaultVariablesColor};">${TIME_COUNTDOWN_MARKER}</strong>`);
        },
      },
      {
        content: `${START_DATE_MARKER}`,
        onAction: () => {
          handleAddText(` <strong style="color: ${defaultVariablesColor};">${START_DATE_MARKER}</strong>`);
        },
      },
      {
        content: `${END_DATE_MARKER}`,
        onAction: () => {
          handleAddText(` <strong style="color: ${defaultVariablesColor};">${END_DATE_MARKER}</strong>`);
        },
      },
      {
        content: `${PREP_START_DATE_MARKER}`,
        onAction: () => {
          handleAddText(` <strong style="color: ${defaultVariablesColor};">${PREP_START_DATE_MARKER}</strong>`);
        },
      },
      {
        content: `${PREP_END_DATE_MARKER}`,
        onAction: () => {
          handleAddText(` <strong style="color: ${defaultVariablesColor};">${PREP_END_DATE_MARKER}</strong>`);
        },
      },
      {
        content: `${COUNTRY}`,
        onAction: () => {
          handleAddText(` <strong style="color: ${defaultVariablesColor};">${COUNTRY}</strong>`);
        },
      },
      {
        content: `${FLAG}`,
        onAction: () => {
          handleAddText(` ${FLAG}`);
        },
      },
      {
        content: `${ZIPCODE}`,
        onAction: () => {
          handleAddText(` <strong style="color: ${defaultVariablesColor};">${ZIPCODE}</strong>`);
        },
      },
    ];
  }, [handleAddText]);

  return (
    <div className="button-container" title="Variables">
      <Popover
        active={popoverActive}
        activator={
          <button className="fn-btn" onClick={togglePopoverActive} disabled={disabled}>
            <Icon source={CodeAddIcon} tone="base" /> <span style={{ fontSize: '12px', fontWeight: '500' }}>Variables</span>
          </button>
        }
        onClose={togglePopoverActive}
      >
        <ActionList actionRole="menuitem" items={commonActions} />
      </Popover>
    </div>
  );
};

export default VariableButton;
